module.exports = __webpack_public_path__ + "img/Img3_204714_CeEt-5-7.b19f6062.jpg";